import {CommandBase} from "./commandBase";
import {RemoteConstantsModel} from "../models/remoteConstants.model";

export class RemoveBuildingCommand extends CommandBase {
    id: string;

    constructor(id: string) {
        super();
        this.id = id;
    }

    execute(data: RemoteConstantsModel): boolean {
        const index = data.buildings.findIndex(u => u.id === this.id);
        if (index < 0) {
            return false;
        }

        data.buildings.splice(index, 1);
        for (const key in data.localization) {
            delete data.localization[key][this.id];
        }

        if (this.id === data.startingBuilding) {
            data.startingBuilding = data.buildings[0].id;
        }

        return true;
    }
}